// node_modules
import "bootstrap";
import objectFitImages from "object-fit-images";
import LazyLoad from "vanilla-lazyload";
import flatpickr from "flatpickr";

// global parts
import "../global/geoLocation";
import "../global/videos";

//Search
import initSearchForm from "../components/searchForm/index";
import initSearchWP from "../components/searchForm/searchWpPlugin";
//components
import "../components/swiper";
import waitForGlobal from "../components/wait-for-global";
import handleForms from "../components/handle-form";
import changeSelectColorForm from "../components/change-select-color-form";
import handleModals from "../components/handle-modals";
import handleWebsiteBanners from "../components/handle-website-banners";
import handleCollapsedMenu from "../components/handle-collapsed-menu";
import adjustCollapseView from "../components/adjust-collapse-view";
import handleMenu from "../components/handle-menu";
import handleExperiments from "../components/handle-experiments";
import toggleShowClassMobileFormOverlay from "../components/toggle-show-class-mobile-form-overlay";
import scrollToPoint from "../components/scroll-to-point";
import addTitleReviewsIframe from "../components/add-title-reviews-iframe";
import globalAccess from "../components/global-access";

//TODO: remove after js per block enabled

import { initDynamicNearbyLocations } from "../components/dynamicNearbyLocations/index";
import getNearestPlaces from "../components/geolocation";
import ThankYou from "../components/form/thank-you";
import { calendly_meeting_scheduled } from "../components/calendly/util";

$(function () {
  handleWebsiteBanners();
  waitForGlobal("MktoForms2", handleForms);
  changeSelectColorForm();
  handleModals();
  handleCollapsedMenu();
  adjustCollapseView();
  handleMenu();
  waitForGlobal("gaData", handleExperiments);
  toggleShowClassMobileFormOverlay();
  scrollToPoint();
  addTitleReviewsIframe();
  // locationSeatsNeeded.init();
  globalAccess.init();

  //lazy loading
  new LazyLoad({
    elements_selector: ".lazy",
  });

  flatpickr(".f_date_and_time", {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    minDate: "today",
    disableMobile: "true",
    static: true,
  });

  const dateInput = document.querySelectorAll(".f_date_and_time");

  dateInput &&
    dateInput.forEach((elem) => {
      elem.addEventListener("click", () => {
        elem.value ? false : (elem.value = " ");
      });
    });

  //IE11 support
  objectFitImages($(".stretch-image"));

  $(window).on("scroll", function () {
    $("body").toggleClass("down", $(window).scrollTop() > 40);
  });

  setTimeout(() => {
    $("[name='viewport']").attr(
      "content",
      "width=device-width, initial-scale=1"
    );

    $("[aria-hidden='true'] *").attr("tabindex", "-1");
  }, 100);

  getNearestPlaces()
    .then((places) => {
      initDynamicNearbyLocations([
        places.locations[0].id,
        places.locations[1].id,
      ]);
    })
    .catch(() => {
      initDynamicNearbyLocations([32234, 30759]);
    });

  //document.querySelector('[data-target="#modal-location-form"]').click();

  if ($("#searchFormGeolocated").length > 0) {
    initSearchForm();
    initSearchWP();
  }

  // Sidebar form height should be set as var
  // banner--form
  const formInnerHeight = $("#js-sidebar-form").length
    ? $("#js-sidebar-form").innerHeight()
    : 640;

  const r = document.querySelector(":root");
  r.style.setProperty("--dl-form-height", formInnerHeight + "px");
});

/* eslint-disable */
window.translate = js_translate;
/* eslint-enable */

function isCalendlyEvent(e) {
  return (
    e.origin === "https://calendly.com" &&
    e.data.event &&
    e.data.event.indexOf("calendly.") === 0
  );
}

//EVENTS
window.addEventListener("message", (e) => {
  if (isCalendlyEvent(e)) {
    if (e.data.event === "calendly.event_scheduled") {
      calendly_meeting_scheduled();
      let form = document.querySelector(".js-calendly")
        ? document
            .querySelector(".js-calendly")
            .parentElement.querySelector("form")
        : false;

      if (form) {
        ThankYou.init();
      } else {
        form = document.querySelector("form.calendly");

        if (form) {
          ThankYou.init();
        }
      }
    }
  }
});
